import type {FC} from 'react';

import type {WithTestID} from '../../utils/utility-types';

import {Clickable} from '../../uikit/Clickable';
import * as S from './styles';

interface Props extends WithTestID {
  badge?: number | string;
  onClick: () => void;
}

export const NotificationsButton: FC<Props> = ({badge, onClick, testID}) => {
  return (
    <S.Container>
      <Clickable onClick={onClick} testID={testID}>
        <S.IconContainer>
          <S.Icon />
          {badge ? <S.Badge /> : null}
        </S.IconContainer>
      </Clickable>
    </S.Container>
  );
};
